/**
 * PERF-02A.1 — Dashboard UI: lectura materializada GET /dashboard
 */
import FirebaseService from './firebase.service';
import { normalizarDatosDashboard, rangoMesActual } from '../utils/normalizarDatosDashboard';

class DashboardService extends FirebaseService {
  constructor() {
    super('');
  }

  async obtenerStats() {
    const response = await this.get('/dashboard');
    const raw = response?.data ?? response;
    if (!raw || typeof raw !== 'object') {
      throw new Error('Respuesta inválida del dashboard');
    }
    return {
      raw,
      hoy: normalizarDatosDashboard(raw)
    };
  }

  /**
   * Métricas ejecutivas desde doc materializado (sin scans de reportes/productos).
   */
  async obtenerMetricasEjecutivas() {
    const { raw, hoy } = await this.obtenerStats();
    const mes = raw.mesActual || {};
    const periodoFallback = rangoMesActual();

    return {
      periodoMes: {
        inicio: mes.periodoInicio || periodoFallback.inicio,
        fin: mes.periodoFin || periodoFallback.fin
      },
      hoy: { ok: true, data: hoy },
      ventasMes: {
        ok: true,
        cantidadVentas: parseInt(mes.cantidadVentas ?? 0, 10) || 0,
        facturacion: parseFloat(mes.facturacion ?? 0) || 0,
        clientesDestacados: Array.isArray(mes.clientesDestacados) ? mes.clientesDestacados : [],
        productosDestacados: Array.isArray(mes.productosDestacados) ? mes.productosDestacados : []
      },
      gananciasMes: {
        ok: true,
        gananciaBruta: parseFloat(mes.gananciaBruta ?? 0) || 0,
        cobertura: mes.finanzasCobertura || null,
        calidadFinanciera: mes.finanzasCalidad || null,
        alertas: Array.isArray(mes.finanzasAlertas) ? mes.finanzasAlertas : [],
        metadata: mes.finanzasMetadata || null,
        actualizadoEn: raw.computedAt || raw.ventasComputedAt || raw.catalogComputedAt || null
      },
      gastosMes: {
        ok: true,
        total: parseFloat(raw.comprasMesTotal ?? 0) || 0
      },
      catalogActivation: raw.catalogActivation || null
    };
  }
}

export default new DashboardService();
